@let _loading = loading();
@let _hasPendingUpdates = hasPendingUpdates();
@let _template = computedTemplateRef();

@if (!_loading) {
  <div class="relative flex flex-1">
    @if (!error()) {
      <div class="relative flex flex-1">
        <div class="flex flex-1">
          @if (!!noDataTemplateRef && !!noData && noData(lastData)) {
            <ng-container
              [ngTemplateOutlet]="noDataTemplateRef.templateRef"
            ></ng-container>
          } @else {
            <div class="flex flex-1 flex-col gap-2">
              @if (_hasPendingUpdates) {
                <div class="flex p-2">
                  <div
                    class="flex flex-1 flex-row items-center justify-start gap-2 border border-blue-600 bg-blue-200 text-blue-600 text-sm p-2 rounded-md"
                  >
                    <i class="fa-solid fa-circle-exclamation"></i>
                    <span>
                      {{ "Sono in corso di aggiornamenti" | transloco }}
                    </span>
                  </div>
                </div>
              }

              <ng-template [ngTemplateOutlet]="_template"></ng-template>
            </div>
          }
        </div>
      </div>
    }

    @if (error()) {
      <div class="flex flex-1 bg-container flex-col justify-center">
        @if (unable()) {
          <div class="flex flex-col items-center justify-center gap-4">
            <i class="fa-thin fa-lock text-orange-200 text-4xl"></i>
            <span class="text-center text-sm text-orange-400">{{
              "Non hai i permessi per visualizzare la risorsa" | transloco
            }}</span>

            @if (unableHttp()) {
              <span class="text-xs text-orange-400">
                {{ "Richiesta HTTP" | transloco }}
              </span>
            } @else if (unableAbility()) {
              <span class="text-xs text-orange-400">
                {{ "Software ability" | transloco }}
              </span>
            }
          </div>
        }

        @if (!unable()) {
          <div class="mt-2 flex flex-col items-center justify-center gap-1">
            <i class="fa-thin fa-face-sad-sweat text-red-300"></i>
            <span class="text-center text-red-400">{{
              "Impossibile caricare la risorsa" | transloco
            }}</span>
          </div>

          <div class="mt-2 flex justify-center align-middle">
            <snt-button
              (onClick)="refresh()"
              [title]="'Riprova' | transloco"
            ></snt-button>
          </div>
        }
      </div>
    }
  </div>
}

@if (_loading) {
  @switch (loaderType()) {
    @case ("spinner") {
      <div
        class="flex items-center justify-center flex-1 bg-container {{
          loaderCssClass ? loaderCssClass : ''
        }}"
      >
        <sl-spinner
          style="
            font-size: 3rem;
            --indicator-color: #475669;
            --track-color: #f1f5f9;
          "
        ></sl-spinner>
      </div>
    }
    @case ("skeleton-page-detail") {
      <div class="flex flex-1 p-2 flex-col gap-2">
        <div class="flex flex-row gap-2">
          <pms-skeleton-loader
            [animation]="'pulse'"
            [theme]="{ flex: 1, width: '192px', height: '192px' }"
            class="w-[192px] flex"
          ></pms-skeleton-loader>

          <div class="flex-1 flex flex-col gap-2">
            <div class="flex flex-row gap-2">
              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ width: '128px', height: '128px' }"
                class="h-[128px] w-[128px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ width: '128px', height: '128px' }"
                class="h-[128px] w-[128px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ width: '128px', height: '128px' }"
                class="h-[128px] w-[128px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ flex: 1, width: '100%', height: '128px' }"
                class="h-[128px] flex flex-1"
              ></pms-skeleton-loader>
            </div>

            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ flex: 1, width: '100%' }"
              class="flex-1 flex"
            ></pms-skeleton-loader>
          </div>
        </div>

        <div class="flex-1 flex flex-row gap-2">
          <div class="flex flex-col gap-2">
            <div class="flex flex-col gap-2">
              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ height: '16px' }"
                class="h-[16px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ height: '16px' }"
                class="h-[16px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ height: '16px' }"
                class="h-[16px] flex"
              ></pms-skeleton-loader>

              <pms-skeleton-loader
                [animation]="'pulse'"
                [theme]="{ height: '16px' }"
                class="h-[16px] flex"
              ></pms-skeleton-loader>
            </div>

            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ width: '192px', height: '128px' }"
              class="w-[192px] h-[128px] flex"
            ></pms-skeleton-loader>

            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ width: '192px', height: '128px' }"
              class="w-[192px] h-[128px] flex"
            ></pms-skeleton-loader>

            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ width: '192px', height: '128px' }"
              class="w-[192px] h-[128px] flex"
            ></pms-skeleton-loader>

            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ flex: 1, width: '192px' }"
              class="flex-1 flex"
            ></pms-skeleton-loader>
          </div>

          <div class="flex-1 flex">
            <pms-skeleton-loader
              [animation]="'pulse'"
              [theme]="{ flex: 1, width: '100%' }"
              class="flex-1 flex"
            ></pms-skeleton-loader>
          </div>
        </div>
      </div>
    }
  }
}
